<template>
  <base-dialog
      :visible="show"
      title="工单详情"
      width="1200px"
      @close="handlerClose"
  >
    <div>
      <div v-if="info.id > 0">
        <el-descriptions :column="2" size="medium">
          <el-descriptions-item label="工单状态">
            <el-tag v-if="info.status === 1" size="mini" type="warning">待处理</el-tag>
            <el-tag v-if="info.status === 2" size="mini">待反馈</el-tag>
            <el-tag v-if="info.status === 3" size="mini" type="success">已结单</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="创建时间">{{info.create_time}}</el-descriptions-item>
          <el-descriptions-item label="工单标题">{{info.title}}</el-descriptions-item>
        </el-descriptions>

        <div v-if="info.children.length > 0" style="margin-top: 1em;">

          <div style="margin-top: 1em;max-height: 40vh;overflow-y: scroll;padding-right: 30px;">

            <div class="message-list">
              <div class="message-item"  v-for="(item,index) in info.children" :key="index">
                <div class="send-nickname">
                  <h3 v-if="item.role_type == 1"><i class="el-icon-bell"></i> 平台客服</h3>
                  <h3 v-else><i class="el-icon-user"></i> {{info.business_user.nickname}}</h3>
                </div>
                <div class="send-date">{{item.create_time}}</div>
                <div class="send-content">{{item.content}}</div>
                <div style="margin-top: .5em;" v-if="item.files.length > 0">
                  <div v-for="(item, index) in item.files" style="margin: .2em 0;">
                    <el-link type="primary" :href="item" icon="el-icon-link" target="_blank" download>附件{{index+1}}</el-link>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div v-if="info.status < 3" style="margin-top: 1em;">
          <el-input
              v-model="payload.content"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 6}"
              placeholder="请输入内容"
          ></el-input>

          <div style="margin-top: 1em;">
            <el-upload
                ref="upload"
                :action="config.baseApi + '/business/upload/default'"
                :limit="5"
                accept=".jpg, .jpeg, .bmp, .png, .gif,
                               .txt, .log, .ini, .conf,
                               .rar, .zip,
                               .doc, .docx,
                               .pdf,
                               .xlsx, .xls,
                               .eml,
                               image/jpeg, image/bmp, image/png, image/gif,
                               text/plain,
                               application/zip, application/vnd.rar,
                               application/msword,
                               application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                               application/pdf,
                               application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                               application/vnd.ms-excel,
                               message/rfc822"
                :on-success="handleSuccess"
                :on-remove="handleRemove"
                :on-error="handleError"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">最多支持5个附件。</div>
            </el-upload>
          </div>

          <div style="display: flex;align-items: center;justify-content: center;gap: 30px;">
            <el-button type="primary" @click="submit">回复</el-button>
          </div>
        </div>
      </div>
    </div>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/baseDialog/baseDialog.vue";
import config from "@/assets/js/conf/config";
import {mapActions} from "vuex";

export default {
  computed: {
    config() {
      return config
    }
  },
  components: {
    BaseDialog
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    info:{
      type: Object,
      default: () => {
        return {
          id: 0,
        }
      }
    },
  },
  data() {
    return {
      show: false,
      payload: {
        content: ''
      },
      reverse:false,
      fileList: [],
    }
  },
  watch: {
    visible(val) {
      this.show = val;
    },
  },
  methods: {
    ...mapActions({
      getWorkOrderList: "ucenter/getWorkOrderList",
      getWorkOrderDetail: "ucenter/getWorkOrderDetail",
      opCreateWorkOrder: "ucenter/opCreateWorkOrder",
      opReplyWorkOrder: "ucenter/opReplyWorkOrder",
      opFinishWorkOrder: "ucenter/opFinishWorkOrder",
    }),
    handlerClose() {
      this.show = false;
      this.$emit('update:visible', false);
      this.$emit('close')
      this.handlerClearForm();
    },
    submit() {
      if(this.payload.content.length < 1 && this.fileList.length < 1){
        this.$message.warning('请输入内容或上传附件！')
        return;
      }

      const payload = Object.assign(this.payload, {files: [], id: this.info.id});

      this.fileList.map(item=>{
        payload.files.push(item.url)
      })
      payload.files = payload.files.join(',')

      this.opReplyWorkOrder({
        data: payload,
        success: (res) => {
          if(res.code===200){
            this.$message({message: res.msg,type: 'success',});
            this.handlerClose()
          } else {
            this.$message({message: res.msg,type: 'error',});
          }
        }
      })
    },
    handleError(err, file) {
      this.$message.error(`${file.name} 上传失败：${err.message}`)
      // 自动移除失败项（2.15版本需手动处理）
      setTimeout(() => {
        const index = this.$refs.upload.uploadFiles.findIndex(f => f.uid === file.uid)
        if (index > -1) {
          this.$refs.upload.uploadFiles.splice(index, 1)
        }
      }, 2000)
    },
    handleSuccess(res, file) {
      if (res.status === 200) {
        this.fileList.push(res.data)
      } else {
        this.$message('上传失败！');
        const index = this.$refs.upload.uploadFiles.findIndex(f => f.uid === file.uid)
        this.$refs.upload.uploadFiles.splice(index, 1);
      }
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
    },
    handlerClearForm() {
      this.payload.content = '';
      this.fileList = [];
    },
  }
}
</script>

<style lang="less" scoped>
.message-list{display: flex;flex-direction: column;width: 100%}
.message-list .message-item{display: flex;flex-direction: column;width: 100%;position: relative;padding: 30px 0;border-bottom: 1px solid #eee;}
.message-list .message-item .send-nickname{font-size: 14px;color: #333333;font-weight: bold;}
.message-list .message-item .send-content{font-size: 14px;color: #3a3a3a;line-height: 26px;margin-top: 20px;text-align: justify;}
.message-list .message-item .send-date{position: absolute;right: 0px;color: #787878;font-size: 12px;}
</style>